import { Link } from "react-router-dom"

const Success = () => (
    <div className="container-success">
        <h2>ご連絡ありがとうございます</h2>
        <Link to="/links">戻る</Link>
    </div>
)

export default Success;